import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  typography: {
    h1: { fontSize: 69 },
    h2: { fontSize: 57 },
    h3: { fontSize: 48 },
    h4: { fontSize: 30, fontWeight: 600 },
    h5: { fontSize: '1.5rem', fontWeight: '550' },
    h6: { fontSize: 18, fontWeight: 700 },
    subtitle1: { fontSize: 23 },
    subtitle2: { fontSize: 19 },
    body1: { fontSize: 15 },
    body2: { fontSize: 14 },
    subtitle3: { fontSize: 16, fontWeight: '580' },
    title1: { fontSize: '15px', fontWeight: '700' },
    title3: { fontSize: '.875rem' },

    title: { fontSize: '0.875rem', fontWeight: '700', lineHeight: '1.66' },
    subtitle: { fontSize: '0.75rem', fontWeight: '700', color: '#757575', lineHeight: '1.4' },

    title2: { fontSize: '14px', fontWeight: '400', color: '#757575', lineHeight: '19px' }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          wordWrap: 'break-word'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '14px'
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '27px'
        }
      }
    },

    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: '540'
        }
      }
    },
    palette: {
      ecoGreen: {
        main: '#8dc647'
      },
      catgPurple: {
        main: 'purple'
      }
    }
  }
});
theme = responsiveFontSizes(theme);

export default theme;
